import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `support-tickets/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Update Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `support-tickets/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'support-tickets',
      method: 'get',
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
      },
    }
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: 'set',
      }
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default { find, list, update }
